import React from "react";
import COLORS from "../../constants/colors";
import InfoMessage from "../common/InfoMessage";
import {
  contentSectionStyle,
  listCardStyle,
  mainCardStyle,
  miniBtnStyle,
  pageStyle,
  sectionTitleStyle,
  smallTopBtnStyle,
} from "../../styles/commonStyles";

export default function MyContentPage({
  state,
  starredWords,
  learnedWords,
  words,
  message,
  onGoHome,
  onOpenWordDetail,
  onSpeakFrench,
  // 新增：接收词书参数
  books = [],
  currentBook,
  onSwitchBook
}) {
  return (
    <div style={pageStyle()}>
      <div style={mainCardStyle()}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          <div
            style={{
              fontSize: "1.35rem",
              fontWeight: 800,
              color: COLORS.text,
            }}
          >
            我的内容
          </div>

          <button onClick={onGoHome} style={smallTopBtnStyle("#E9EEF5")}>
            ⌂
          </button>
        </div>

        <InfoMessage message={message} />

        {/* 词书模块 - 支持切换 */}
        <section style={contentSectionStyle()}>
          <div style={sectionTitleStyle()}>词书</div>
          
          {/* 词书切换下拉框 */}
          <div style={{ marginTop: "0.6rem" }}>
            <select
              value={currentBook?.id || ""}
              onChange={(e) => {
                const selected = books.find(b => b.id === e.target.value);
                selected && onSwitchBook(selected);
              }}
              style={{
                width: "100%",
                padding: "0.6rem 0.8rem",
                borderRadius: "8px",
                border: "1px solid #E9EEF5",
                fontSize: "0.95rem",
                backgroundColor: "#fff",
                color: COLORS.text,
                outline: "none",
                cursor: "pointer",
              }}
            >
              {books.map(book => (
                <option key={book.id} value={book.id}>
                  {book.name} 
                </option>
              ))}
            </select>
          </div>

          <div
            style={{
              marginTop: "0.6rem",
              color: COLORS.subtext,
              fontSize: "0.9rem",
            }}
          >
            当前词书：{currentBook?.name || "基础法语词书"}
          </div>
        </section>

        <section style={contentSectionStyle()}>
          <div style={sectionTitleStyle()}>单词本</div>
          {starredWords.length === 0 ? (
            <div style={{ color: COLORS.subtext }}>还没有收藏的单词</div>
          ) : (
            <div style={{ display: "grid", gap: "0.7rem" }}>
              {starredWords.map((w) => (
                <div key={w.id} style={listCardStyle()}>
                  <div>
                    <div style={{ fontWeight: 700, color: COLORS.text }}>{w.word}</div>
                    <div style={{ color: COLORS.subtext, fontSize: "0.9rem" }}>
                      {w.translation}
                    </div>
                  </div>

                  <button
                    onClick={() => onOpenWordDetail(w.id)}
                    style={miniBtnStyle()}
                  >
                    查看
                  </button>
                </div>
              ))}
            </div>
          )}
        </section>

        <section style={contentSectionStyle()}>
          <div style={sectionTitleStyle()}>笔记</div>
          {Object.keys(state.user.notes).length === 0 ? (
            <div style={{ color: COLORS.subtext }}>还没有笔记</div>
          ) : (
            <div style={{ display: "grid", gap: "0.7rem" }}>
              {Object.entries(state.user.notes).map(([wordId, note]) => {
                const word = words.find((w) => w.id === Number(wordId));
                return (
                  <div key={wordId} style={listCardStyle()}>
                    <div>
                      <div style={{ fontWeight: 700 }}>{word?.word}</div>
                      <div
                        style={{
                          color: COLORS.subtext,
                          fontSize: "0.88rem",
                          marginTop: "0.2rem",
                        }}
                      >
                        {String(note).slice(0, 40) || "（空笔记）"}
                      </div>
                    </div>

                    <button
                      onClick={() => onOpenWordDetail(Number(wordId))}
                      style={miniBtnStyle()}
                    >
                      打开
                    </button>
                  </div>
                );
              })}
            </div>
          )}
        </section>

        <section style={contentSectionStyle()}>
          <div style={sectionTitleStyle()}>已学列表</div>
          {learnedWords.length === 0 ? (
            <div style={{ color: COLORS.subtext }}>你还没有学过单词</div>
          ) : (
            <div style={{ display: "grid", gap: "0.7rem" }}>
              {learnedWords.map((w) => (
                <div key={w.id} style={listCardStyle()}>
                  <div>
                    <div style={{ fontWeight: 700, color: COLORS.text }}>{w.word}</div>
                    <div style={{ color: COLORS.subtext, fontSize: "0.9rem" }}>
                      {w.phonetic} · {w.translation}
                    </div>
                  </div>

                  <div style={{ display: "flex", gap: "0.5rem" }}>
                    <button
                      onClick={() => onSpeakFrench(w.word)}
                      style={miniBtnStyle()}
                    >
                      🔊
                    </button>
                    <button
                      onClick={() => onOpenWordDetail(w.id)}
                      style={miniBtnStyle()}
                    >
                      详情
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>

        <section style={contentSectionStyle()}>
          <div style={sectionTitleStyle()}>错题本</div>
          {state.user.wrongWordBook.length === 0 ? (
            <div style={{ color: COLORS.subtext }}>当前还没有进入错题本的单词</div>
          ) : (
            <div style={{ display: "grid", gap: "0.7rem" }}>
              {state.user.wrongWordBook.map((item, idx) => {
                const word = words.find((w) => w.id === item.wordId);
                return (
                  <div key={`${item.wordId}-${idx}`} style={listCardStyle()}>
                    <div>
                      <div style={{ fontWeight: 700, color: COLORS.text }}>
                        {word?.word || "未知单词"}
                      </div>
                      <div style={{ color: COLORS.subtext, fontSize: "0.9rem" }}>
                        {word?.translation || "--"}
                      </div>
                      <div
                        style={{
                          color: COLORS.subtext,
                          fontSize: "0.82rem",
                          marginTop: "0.2rem",
                        }}
                      >
                        原因：{item.reason} · {item.addedAt}
                      </div>
                    </div>

                    <button
                      onClick={() => word && onOpenWordDetail(word.id)}
                      style={miniBtnStyle()}
                    >
                      查看
                    </button>
                  </div>
                );
              })}
            </div>
          )}
        </section>

        <section style={contentSectionStyle()}>
          <div style={sectionTitleStyle()}>法语记忆胶囊</div>
          {state.user.memoryCapsules.length === 0 ? (
            <div style={{ color: COLORS.subtext }}>还没有生成记忆胶囊</div>
          ) : (
            <div style={{ display: "grid", gap: "0.8rem" }}>
              {state.user.memoryCapsules.map((c) => (
                <div
                  key={c.id}
                  style={{
                    ...listCardStyle(),
                    alignItems: "flex-start",
                  }}
                >
                  <div>
                    <div style={{ fontWeight: 700, color: COLORS.text }}>
                      💌 {c.title}
                    </div>
                    <div style={{ color: COLORS.subtext, marginTop: "0.25rem" }}>
                      {c.date}
                    </div>
                    <div style={{ marginTop: "0.5rem", lineHeight: 1.7 }}>
                      {c.desc}
                    </div>
                    <div
                      style={{
                        marginTop: "0.55rem",
                        color: COLORS.blue,
                        fontStyle: "italic",
                      }}
                    >
                      {c.quote}
                    </div>
                    <div
                      style={{
                        marginTop: "0.4rem",
                        color: COLORS.subtext,
                        fontSize: "0.88rem",
                      }}
                    >
                      {c.soundMemory}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>
      </div>
    </div>
  );
}